/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_EyebrowInputs */

const es_landing_pricing_eyebrow = /** @type {(inputs: Landing_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifas, sin sorpresas`)
};

const gl_landing_pricing_eyebrow = /** @type {(inputs: Landing_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifas, sen sorpresas`)
};

const en_landing_pricing_eyebrow = /** @type {(inputs: Landing_Pricing_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing, no surprises`)
};

/**
* | output |
* | --- |
* | "Pricing, no surprises" |
*
* @param {Landing_Pricing_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_eyebrow = /** @type {((inputs?: Landing_Pricing_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_pricing_eyebrow(inputs)
	if (locale === "en") return en_landing_pricing_eyebrow(inputs)
	return es_landing_pricing_eyebrow(inputs)
});